import axios from "axios";
import endPoints from "../../../../../config/endPoints";

export const getAllReferenceByKindApi = async(reqBody) => {  
  return await axios.post(`${endPoints.references}/kindId`, reqBody);  
};

export const getAllReferences = async (reqBody) => {
  return await axios.post(endPoints.references, reqBody);
};

export const getAllReferencesKinds = async (reqBody) => {
  return await axios.post(endPoints.kinds, reqBody);
};